"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbUtils = require("ykb-utils");
var Iban = function Iban(_ref) {
  var value = _ref.value;
  var formattedValue = (0, _ykbUtils.ibanFormatter)(value);
  if (!formattedValue) return null;
  var prefixCls = 'ykb-iban-text';
  var ibanNumber = formattedValue.slice(0, 22);
  var accountNumber = formattedValue.slice(22);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls)
  }, ibanNumber, /*#__PURE__*/_react.default.createElement("strong", null, accountNumber));
};
var _default = exports.default = Iban;